import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { type FC } from "react"

import { type ThinPrivateSession } from "@forento/core/models/privateSession"
import { toPriceString } from "@forento/core/utilities/currency"

import { DeleteIcon, EditIcon } from "~/components/Icon"
import ProductListRow from "~/components/ProductListRow"
import { useAlert } from "~/contexts/AlertContext"
import routes from "~/utilities/routes"
import trpc from "~/utilities/trpc"

type Props = { session: ThinPrivateSession; reload(): Promise<unknown> }
const Session: FC<Props> = ({ session, reload }) => {
	const alert = useAlert()
	const { setNodeRef, transform, transition, attributes, listeners } = useSortable({ id: session.id })

	async function handleDelete() {
		const dialog = await alert.confirm(
			"Delete session",
			`Are you sure you want to delete the session **${session.title}**?` +
				(session.hasSales
					? "\n\n**Warning:** it has sales. Deleting it removes the buyers' access to it."
					: ""),
		)
		if (!dialog.result) return
		await trpc.privateSession.delete.mutate(session.id)
		await reload()
		dialog.close()
	}

	return (
		<ProductListRow
			ref={setNodeRef}
			title={session.title}
			sticker={
				session.isManualOnly
					? "Manual only"
					: session.price
						? toPriceString(session.price)
						: session.membershipIds.length > 0
							? "Membership"
							: "Free"
			}
			actions={[
				{ id: "edit", tooltip: "Edit", icon: EditIcon, href: routes.sessions.edit(session.id) },
				{ id: "delete", tooltip: "Delete", icon: DeleteIcon, danger: true, onClick: handleDelete },
			]}
			dragHandle={{ attributes, listeners }}
			style={{ transform: CSS.Transform.toString(transform), transition }}
		/>
	)
}

export default Session
